import http from "api/https";

export const getroles = (): Promise<any> => {
  return http.get("/role/GetAll");
};
